const ANIMATION_EFFECTS = ["fadeUp", "fadeIn", "slideLeft", "slideRight", "scaleIn"];
const ANIMATABLE_BLOCKS = /* @__PURE__ */ new Set(["constellation/button", "constellation/button-group", "constellation/card", "constellation/heading", "constellation/image", "constellation/paragraph", "constellation/group", "constellation/grid-layout"]);
const STAGGER_BLOCKS = /* @__PURE__ */ new Set(["constellation/button-group", "constellation/group", "constellation/grid-layout"]);
const HOVER_EFFECTS = ["scale"];
const HOVER_BLOCKS = /* @__PURE__ */ new Set(["constellation/button", "constellation/card"]);
const MAX_STAGGER_ITEMS = 8;
const DURATION_STEPS = ["fast", "default", "slow"];
const DELAY_STEPS = ["none", "short", "default", "long"];
const STAGGER_STEPS = ["tight", "default", "loose"];
const toStep = (value, steps) => steps.includes(value) ? value : "default";
const isEffect = (v) => ANIMATION_EFFECTS.includes(v);
const getBlockAnimation = (block) => {
  var _a;
  if (!ANIMATABLE_BLOCKS.has(block.blockName)) return null;
  const attrs = block.attrs ?? {};
  if (!isEffect(attrs.animationEffect)) return null;
  const config = {
    effect: attrs.animationEffect,
    duration: toStep(attrs.animationDuration, DURATION_STEPS),
    delay: toStep(attrs.animationDelay, DELAY_STEPS),
    replay: attrs.animationReplay === true
  };
  if (attrs.animationStagger && STAGGER_BLOCKS.has(block.blockName)) {
    config.stagger = {
      step: toStep(attrs.animationStaggerDelay, STAGGER_STEPS),
      reverse: attrs.animationStaggerReverse === true,
      count: ((_a = block.innerBlocks) == null ? void 0 : _a.length) ?? 0
    };
  }
  return config;
};
const getBlockHover = (block) => {
  var _a;
  if (!HOVER_BLOCKS.has(block.blockName)) return null;
  const effect = (_a = block.attrs) == null ? void 0 : _a.hoverEffect;
  return HOVER_EFFECTS.includes(effect) ? effect : null;
};
const staggerSlot = (index, {
  reverse,
  count
}) => {
  const position = reverse ? Math.max(0, count - 1 - index) : index;
  return Math.min(position, MAX_STAGGER_ITEMS - 1);
};
const ANIMATION_ATTR_KEYS = ["animationEffect", "animationDuration", "animationDelay", "animationStagger", "animationStaggerDelay", "animationStaggerReverse", "animationReplay", "hoverEffect"];
const stripAnimationAttrs = (block) => {
  const attrs = block.attrs;
  if (!attrs || !ANIMATION_ATTR_KEYS.some((key) => key in attrs)) {
    return block;
  }
  const rest = {
    ...attrs
  };
  ANIMATION_ATTR_KEYS.forEach((key) => delete rest[key]);
  return {
    ...block,
    attrs: rest
  };
};
const pickAnimationDomProps = (attrs) => Object.fromEntries(Object.entries(attrs ?? {}).filter((entry) => entry[0].startsWith("data-cms-") && typeof entry[1] === "string"));
export {
  ANIMATABLE_BLOCKS,
  ANIMATION_EFFECTS,
  DELAY_STEPS,
  DURATION_STEPS,
  HOVER_BLOCKS,
  HOVER_EFFECTS,
  MAX_STAGGER_ITEMS,
  STAGGER_BLOCKS,
  STAGGER_STEPS,
  getBlockAnimation,
  getBlockHover,
  pickAnimationDomProps,
  staggerSlot,
  stripAnimationAttrs
};
